/**
 * Human-readable payment-term label for React render.
 * API may return a plain string (`paymentTermName`) or a PaymentTerm object
 * (`paymentTerm` / `paymentTermObject`) — never pass the object to JSX.
 *
 * Object priority: description → condition ref name → fallback.
 */

export type PaymentTermLike = {
  condition?: string | null;
  description?: string | null;
} | null | undefined;

export type PaymentTermConditionRef = {
  code?: string | null;
  name?: string | null;
} | null | undefined;

export function paymentTermLabel (
  term: string | PaymentTermLike,
  paymentTermConditions?: PaymentTermConditionRef[] | null,
  fallback = "-"
): string {
  if (typeof term === "string") {
    const trimmed = term.trim();
    return trimmed || fallback;
  }
  if (!term || typeof term !== "object") return fallback;

  const desc = term.description != null ? String(term.description).trim() : "";
  if (desc) return desc;

  const fromRef = paymentTermConditions?.find((f) => f?.code && f.code === term.condition)?.name;
  if (fromRef && String(fromRef).trim()) return String(fromRef).trim();

  return fallback;
}
